import React, { Fragment, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { FaFacebookF } from "react-icons/fa";
import { BsArrowUpSquare } from "react-icons/bs";
import { GrLinkedinOption } from "react-icons/gr";
import { AiFillInstagram } from "react-icons/ai";
import { Base_URL } from "../BaseURL";
// import { GrTwitter } from "react-icons/gr";
import { GrYoutube } from "react-icons/gr";
import FooterLogo from "../../ImagesComponents/EZ-Marketing-Agency-White.svg";
import nounCall from "../../ImagesComponents/bannerImg/noun-call.png";
import { MdClose } from "react-icons/md";
let envelope = [
  "https://ezmarketingtech.s3.amazonaws.com/img/email-envelope.svg",
  "https://ezmarketingtech.s3.amazonaws.com/img/footer-shaps.png",
  "https://ezmarketingtech.s3.amazonaws.com/img/footer-shaps2.png",
  "https://ezmarketingtech.s3.amazonaws.com/img/x__twitter-logo.png",
];

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisible = () => {
      if (
        document.body.scrollTop > 500 ||
        document.documentElement.scrollTop > 500
      ) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);
  const [addClass, setaddClass] = useState(" ");
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <Fragment>
      <footer id="rs-footer" className="rs-footer style1 modify3 main-footer">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="250 0 1000 150"
          className="footer_svg"
        >
          <path
            fill="#000214"
            fillOpacity="1"
            d="M0,192L60,170.7C120,149,240,107,360,85.3C480,64,600,64,720,80C840,96,960,128,1080,117.3C1200,107,1320,53,1380,26.7L1440,0L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          ></path>
        </svg>
        <div className="subscribe-bg">
          <img
            src={envelope[1]}
            alt="overlay-img"
            className="footer_overlay footer_overlay1"
            height='500'
          />
          <img
            src={envelope[2]} 
            alt="overlay-img"
            className="footer_overlay footer_overlay2"
            height='500'
          />
          <div className="container">
            <div className="subscribe-top">
              <div className="footer-logo md-mb-30">
                <a href="https://ezmarketing.agency" className="sec-logo-wrap">
                  <img
                    src={FooterLogo}
                    alt="Logo Secondary"
                    height="70"
                    width="125"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-top ">
          <div className="container">
            <div className="row mb-5">
              <div className="col-lg-3 col-md-6 col-sm-6  col-12 md-mb-30">
                <h3 className="widget-title">Featured Services</h3>
                <ul className="site-map">
                  <li>
                    <NavLink to="/us/seo-services">
                      Search Engine Optimization
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/amazon-seo-services">Amazon SEO</NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/ppc-marketing">
                      Pay Per Click / Adwords
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/content-marketing-services">
                      Content Marketing
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/social-media-marketing">
                      Social Media Marketing
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/reputation-management-services">
                      Reputation Management
                    </NavLink>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-md-6 col-sm-6  col-12 md-mb-30">
                <h3 className="widget-title">Helpful Links</h3>
                <ul className="site-map">
                  <li>
                    <NavLink to="/us/seo-packages">Pricing</NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/who-we-are">Who are we?</NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/us/blog">Blog</NavLink>
                  </li> */}
                  <li>
                    <a href="https://ezmarketing.agency/blog">Blog</a>
                  </li>
                  <li>
                    <NavLink to="/us/reviews">Reviews</NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/ecommerce-seo-services">
                      E-Commerce SEO
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/cbd">CBD Marketing</NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/services-ads">Ads Services </NavLink>
                  </li>
                </ul>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6  col-12 md-mt-3">
                <h3 className="widget-title">Location</h3>
                <ul className="site-map row">
             
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-nevada">Nevada</NavLink> */}
                    <NavLink to="/us/seo-company-nevada">Nevada</NavLink>
                  </li>
                  
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-california">California</NavLink> */}
                    <NavLink to="/us/seo-company-california">California</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-colorado">Colorado</NavLink> */}
                    <NavLink to="/us/seo-company-colorado">Colorado</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-maryland">Maryland</NavLink> */}
                    <NavLink to="/us/seo-company-maryland">Maryland</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-texas">Texas</NavLink> */}
                    <NavLink to="/us/seo-company-texas">Texas</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-new-york">New York</NavLink> */}
                    <NavLink to="/us/seo-company-new-york">New York</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-florida">Florida </NavLink> */}
                    <NavLink to="/us/seo-company-florida">Florida</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-michigan">Michigan </NavLink> */}
                    <NavLink to="/us/seo-company-michigan">Michigan</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-pennsylvania">Pennsylvania </NavLink> */}
                    <NavLink to="/us/seo-company-pennsylvania">Pennsylvania</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-washington">Washington </NavLink> */}
                    <NavLink to="/us/seo-company-washington">Washington</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-georgia">Georgia </NavLink> */}
                    <NavLink to="/us/seo-company-georgia">Georgia</NavLink>
                  </li> 
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-illinois">Illinois </NavLink> */}
                    <NavLink to="/us/seo-company-illinois">Illinois</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-utah">Utah </NavLink> */}
                    <NavLink to="/us/seo-company-utah">Utah</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-ohio">Ohio </NavLink> */}
                    <NavLink to="/us/seo-company-ohio">Ohio </NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-wyoming">Wyoming </NavLink> */}
                    <NavLink to="/us/seo-company-wyoming">Wyoming</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    {/* <NavLink to="/us/seo-company-arizona">Arizona </NavLink> */}
                    <NavLink to="/us/seo-company-arizona">Arizona </NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <NavLink to="/us/seo-company-iowa">Iowa</NavLink>
                 
                  </li>

                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <NavLink to="/us/seo-company-nebraska">Nebraska</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <NavLink to="/us/seo-company-indiana">Indiana</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <NavLink to="/us/seo-company-north-dakota">North Dakota</NavLink>
                  </li>
                  <li className="col-12 col-sm-12 col-md-4 col-lg-4">
                    <NavLink to="/us/seo-company-south-dakota">South Dakota</NavLink>
                  </li>
                  
                
                </ul>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6  col-12 md-mt-3 col-sm-nb-5">
                <h3 className="widget-title">Contact Us Now</h3>
                <address className="web_add">
                  EZ Marketing Agency
                  <br />
                  8605 Santa Monica,
                  <br />
                  Blvd #15749, West Hollywood,
                  <br />
                  California 90069-4109 US
                </address>
                <a
                  href="tel:+1 (855) 781-2099"
                  className="info-text contact_secondary"
                >
                  +1 (855) 781-2099
                </a>
                <br />
                <a
                  href="mailto:sales@ezmarketing.agency"
                  className="info-text mail_secondary"
                >
                  sales@ezmarketing.agency
                </a>
                <br />
                <ul className="footer-social md-mb-30">
                  <li>
                    <a
                      href="https://www.facebook.com/ezmarketingagencyusa/"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="For facebook page"
                    >
                      <span>
                        <FaFacebookF />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/10236082"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="For linked-in page"
                    >
                      <span>
                        <GrLinkedinOption />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/EzmarketingUsa"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="For Twitter page"
                    >
                      <span>
                        <img
                          src={envelope[3]}
                          height="70"
                          width="64"
                          alt="icon"
                          className="new_twitter_icon"
                        />
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCU1DcAmBpnswfX88X3E7XTA"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="For Youtube page"
                    >
                      <span>
                        <GrYoutube />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/ezmarketingagency_/"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="For Instagram page"
                    >
                      <span>
                        <AiFillInstagram />
                      </span>
                    </a>
                  </li>
                </ul>
                <NavLink to="contact-us" className="get_in_btn">
                  Get in Touch
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row y-middle">
              <div className="col-lg-7 col-md-7 col-sm-7 col-xs-12 text-right  order-last">
                <ul className="copy-right-menu">
                  <li>
                    <NavLink to="/us/cancellation-policy">
                      Cancellation and Refund Policy
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/privacy-policy">Privacy Policy</NavLink>
                  </li>
                  <li>
                    <NavLink to="/us/terms-and-conditions">Terms and Conditions</NavLink>
                  </li>
                </ul>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                <div className="copyright">
                  <p>
                    &copy;2024 <NavLink to="/us"> EZ Marketing Agency</NavLink> |
                    <NavLink to="/us"> All Rights Reserved.</NavLink>
                  </p>
                </div>
              </div>
            </div>

            <div className="expand-btn-inner  quote_overlay">
              <ul className="info_menu">
                <li className="rsphone">
                  <a href="tel:+1 (855) 781-2099">
                    <img src={nounCall} alt="img" width="32" height="26" />
                    <span>+1 (855) 781-2099</span>
                  </a>
                </li>
                <br />

                <li className="btn-quote">
                  <NavLink onClick={() => setaddClass("openForm")}>
                    <img
                      src={envelope[0]}
                      alt="envelope"
                      width="32"
                      height="26"
                    />
                    <span>Get A Quote</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {isVisible && (
          <span onClick={scrollToTop} className="back_to_top">
            <BsArrowUpSquare />
          </span>
        )}
        {/* <span onClick={scrollToTop} className="back_to_top">
          <BsArrowUpSquare />
        </span> */}
      </footer>
      <div className="quote_form_wrapper" id={addClass}>
        <form
          className="quote_form"
          action={`${Base_URL}/get-quote`}
          method="POST"
        >
          <span className="close-form" onClick={() => setaddClass(" ")}>
            <MdClose />
          </span>
          <div className="row mx-6 get-quote-home">
            <input
              className="from-control"
              type="hidden"
              id="key"
              name="key"
              value="get-quote"
            />

            <div className="col-12 col-sm-12 col-md-6 mb-3 px-6">
              <input
                type="text"
                name="name"
                className="form-controll"
                placeholder="Your Name"
                required={true}
              />
            </div>

            <div className="col-12 col-sm-12 col-md-6 mb-3 px-6">
              <input
                type="tel"
                name="phone"
                className="form-controll"
                placeholder="Phone Number"
                required={true}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-12 mb-3 px-6">
              <input
                type="email"
                name="email"
                className="form-controll"
                placeholder="Email"
                required={true}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-12 mb-3 px-6">
              <input
                type="text"
                name="subject"
                className="form-controll"
                placeholder="Website URL"
                required={true}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-12 px-6">
              <textarea
                name="message"
                width="100%"
                rows="6"
                placeholder="Message"
                required={true}
              ></textarea>
            </div>
            <div className="get-quote-btn">
              <div className="form recaptcha_group mb-0">
                {/* <ReCAPTCHA
                  sitekey="6LfYM_oUAAAAAAkkme8vL33ls2GEqWhU3ZRCNX4C"
                  onChange={setTimeout(onChange, 2000)}
                  className="recaptcha"
                  ref={captchaRef}
                /> */}
              </div>
            </div>
            <button
              // disabled={!isCaptchaSuccessful}
              className="readon submit new"
            >
              Submit Now
            </button>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

export default Footer;
